// extracted by mini-css-extract-plugin
export default {"modalContainer":"Hba","fadeIn":"Iba","img":"Jba","fadeInImg":"Kba","greeting":"Lba","fadeInGreeting":"Mba","imgWrapper":"Nba","name":"Oba","fadeInName":"Pba"};
    if(module.hot) {
      // 1743628931552
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  